export default "__VITE_ASSET__PhyI9Ei8__"